import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';

// create/update are deliberately not implemented: the backend exposes segments as
// read-only by design (segments are seeded, not authored through the API).
export const SegmentService = {
    getByInstitution: async (page = 0, size = 100) => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.get(`${ENDPOINTS.SEGMENT.LIST_BY_INSTITUTION(institutionId!)}?page=${page}&size=${size}`);
        return res.data; // Page<Segment>
    },
};
